var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0069E0;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M759.9,0C650.1-0.2,544.2,40.8,463.1,114.7s-131.6,175.7-141.4,285c-9.9,109.3,21.6,218.4,88.1,305.7 L18.7,1096.6C7,1107.7,0.2,1123.1,0,1139.3c-0.2,16.2,6.1,31.7,17.5,43.2c11.4,11.4,27,17.8,43.2,17.5c16.2-0.2,31.6-7,42.7-18.7 l391.1-391c74.4,56.4,164.9,87.7,258.3,89.3S937.7,852.9,1014,799c76.3-53.9,133.4-130.7,163.2-219.2 c29.7-88.5,30.5-184.3,2.2-273.3c-28.3-89-84.2-166.7-159.6-221.8C944.3,29.6,853.3-0.1,759.9,0L759.9,0z M759.9,760.3 c-84.9,0-166.4-33.7-226.4-93.8c-60-60-93.8-141.5-93.8-226.4c0-84.9,33.7-166.4,93.8-226.4s141.5-93.8,226.4-93.8 c84.9,0,166.4,33.7,226.4,93.8c60,60,93.8,141.5,93.8,226.4c-0.1,84.9-33.8,166.3-93.9,226.3C926.2,726.4,844.8,760.2,759.9,760.3 L759.9,760.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4a8f4a270cec7a1c4858aa3a0fa70e6a.svg";
export { ForwardRef as ReactComponent };